export function buildClientPrefixedPath(
  path: string,
  clientId: string
): string {
  const safePath = path || '';
  const normalized = safePath.startsWith('/') ? safePath : `/${safePath}`;
  if (normalized === '/') return `/clientId/${clientId}`;
  return `/clientId/${clientId}${normalized}`;
}
